import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import SourceDistributionResponse from '../responses/SourceDistributionResponse'

const useSourceDistribution = () => {
	const [data, setData] = useState<SourceDistributionResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/source-distribution`)
			.then(res => setData(res.data))
			.finally(() => setIsLoading(false))
	}, [])

	const total = data
		? data.buyNewOffline + data.buyNewOnline + data.buyUsedOffline + data.buyUsedOnline +
		  data.library + data.borrowStore + data.borrowFriends + data.subscription +
		  data.others + data.notProvided
		: 0

	return [data, total, isLoading] as const
}

export default useSourceDistribution
